import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const DEFAULT_DESC = "askFOGRA is a community Q&A platform where you can ask questions, get real answers, review brokers, and report financial scams.";
const DEFAULT_IMAGE = "https://askfogra.com/og-image.png";
const SITE_NAME = "askFOGRA";
const SITE_URL = "https://askfogra.com";

export default function SEO({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_IMAGE,
  url,
  type = "website",
  noindex = false,
  jsonLd = null,
}) {
  const location = useLocation();
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Ask. Answer. Know.`;
  const fullUrl = url ? `${SITE_URL}${url}` : `${SITE_URL}${location.pathname}`;
  const fullImage = image.startsWith("http") ? image : `${SITE_URL}${image}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph (Facebook, WhatsApp, LinkedIn) */}
      <meta property="og:title"       content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image"       content={fullImage} />
      <meta property="og:url"         content={fullUrl} />
      <meta property="og:type"        content={type} />
      <meta property="og:site_name"   content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image"       content={fullImage} />

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
